// extracted by mini-css-extract-plugin
export default {"content":"WagonsReport_content__4lpCR"};